import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import ModalDialog from "views/Widgets/Common/ModalDialog";
import TableComponent from "views/Widgets/Common/TableComponent";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import NumberFormat from "react-number-format";
import apiform from "utils/APIForm";
import api from "utils/API";
import DocumentosAdjuntosTarea from "components/ClinicalRequests/DocumentosAdjuntosTarea";
import moment from "moment-timezone";
import "moment/locale/es";
moment.locale("es");

function NumberFormatCustom(props) {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={values => {
        onChange({
          target: {
            name: props.name,
            value: values.value
          }
        });
      }}
      thousandSeparator
      isNumericString
      prefix="$"
    />
  );
}

NumberFormatCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
};


const ModalAddAuthorization = props => {
  const {
    openModal,
    closeModal,
    tempRow,
    onActionComplete,
  } = props;

  const [approvalFile, setApprovalFile] = useState(null);
  const [transferPrice, setTransferPrice] = useState(0);
  const [listAsssigned, setlistAsssigned ] = useState([])
  const [indications, setindications] = useState("");
  const [typeTransfer, settypeTransfer] = useState("");
  const [listStop, setlistStop] = useState([])

  const header = [
    {label: "Cargo asignado"},
    {label: "Fecha inicio"},
    {label: "Fecha fin"},
  ]
  const headerStop = [
    {label: "Viaje"},
    {label: "Fecha"},
    {label: "Dirección"},

  ]


    useEffect(() => {
      initialCharge();
    }, []);
  
    const initialCharge = () => {
    
      api.get(`/api/paciente/${tempRow.id_solicitud_paciente.id_paciente_id}/solicitudes/traslados/${tempRow.id_solicitud_paciente.id}/`).then(response => {
        setlistAsssigned(response.data.asignaciones.map((row) => {
            return [
            {value: row.id_cargo_asignado__nombre_corto},
            {value: moment(row.fecha_hora).format("YYYY-MM-DD hh:mm")},
            {value: moment(row.fecha_final).format("YYYY-MM-DD hh:mm")},
            ]
        }))
        setindications(response.data.traslado.indicaciones_generales)
        settypeTransfer(response.data.traslado.tipo_motivo_traslado)
        setlistStop(response.data.traslado.paradas.map((row) => {
            const address = `${row.direccion_region}, ${row.direccion_comuna}, ${row.direccion_calle} ${row.direccion_numero}, ${row.direccion_block}`  
            return [
              {value: row.tipo_parada},
              {value: moment(row.fecha_hora).format("YYYY-MM-DD hh:mm")},
              {value: address},
            ]
        }))
  
        })
  
    }


  const uploadAuthorization = (check=true, postUploadFile=false) => {

    const formData = new FormData();
    const requestList = []
    requestList.push(api.patch(`api/paciente/${tempRow.id_solicitud_paciente.id_paciente_id}/solicitudes/traslados/${tempRow.id_solicitud_paciente.id}/`,{valor_traslado: transferPrice, autorizacion:check}))
    if (check){
      formData.append("archivo", approvalFile[0]);
      formData.append("tipo_documento", "AutorizacionExamenesIsapre");
      formData.append("nombre_archivo", approvalFile[0].name);
      formData.append("id_paciente", parseInt(tempRow.id_ficha.id_paciente.id));
      formData.append("id_solicitud_paciente", parseInt(tempRow.id_solicitud_paciente.id));
      requestList.push(apiform.post(`/api/paciente/${tempRow.id_ficha.id_paciente.id}/solicitudes/traslados/${tempRow.id_solicitud_paciente.id}/documentos/autorizacion_traslado/subir/`, formData))
    }

    if (postUploadFile){
      const body = {
        tipo_documento: "AutorizacionExamenesIsapre",
        solicitud_paciente: tempRow.id_solicitud_paciente.id
      }
      requestList.push(
        api.post(`api/paciente/posponer/autorizacion/isapre/`, body)
      ) 
      
    }
    
    Promise.all(requestList).then(() => {
      onActionComplete && onActionComplete();
      closeModal();
    });
  };

  const rejectRequest= () => {

    api.put(`api/paciente/${tempRow.id_solicitud_paciente.id_paciente_id}/solicitudes/traslados/${tempRow.id_solicitud_paciente.id}/cancelar/`,{}).then(() => {
      onActionComplete && onActionComplete();
      closeModal();
    })

  };

  const handleDownloadIsapreFile = () => {
    api.get(`api/paciente/descargar/traslado/info/isapre/${tempRow.id_solicitud_paciente.id}/${transferPrice}/`, { responseType: "blob" }).then(response => {
      var blob = new Blob([response.data], { type: response.headers["content-type"] });
      var url = window.URL.createObjectURL(blob);
      var a = document.createElement('a');
      a.href = url;
      a.download = "info_traslado_isapre.xlsx";
      document.body.appendChild(a);
      a.click();
      a.remove();
    })
  }

  const _content_ = <div>
              <Grid container justify="center">
              <Grid item container xs={12} justify="center" spacing={1}>
                <Grid item xs={1} />
                <Grid item xs={5}>
                  <Typography variant="body2" gutterBottom>
                    Tipo traslado:
                    <span style={{ fontWeight: "bold" }}>{typeTransfer}</span>
                  </Typography>
                </Grid>
                <Grid item xs={5}>
                  <Typography variant="body2" gutterBottom>
                    Indicaciones:
                    <span style={{ fontWeight: "bold" }}>{indications}</span>
                  </Typography>
                </Grid>
                <Grid item xs={1} />
              </Grid>
            </Grid>
          <Grid
            item
            container
            xs={12}
            justify="center"
            style={{ marginTop: "1em" }}
          >
            <Grid item container xs={12} justify="center">
              {approvalFile != null ? (
                approvalFile[0].name
              ) : (
                <span></span>
              )}
            </Grid>
            <input
              id="contained-button-file-isapre"
              type="file"
              onChange={e => setApprovalFile(e.target.files)}
              hidden
            />
            <label htmlFor="contained-button-file-isapre">
              <Button
                variant="contained"
                color="primary"
                component="span"
                style={{ textTransform: "none" }}
              >
                Adjuntar autorización de isapre
              </Button>
            </label>
          </Grid>
       
          <Grid
            item
            container
            xs={12}
            justify="center"
            style={{ marginTop: "1em" }}
          >
            <TextField
              label="Valor del traslado"
              value={transferPrice}
              onChange={e => setTransferPrice(parseInt(e.target.value))}
              name="numberformat"
              id="formatted-numberformat-input"
              InputProps={{
                inputComponent: NumberFormatCustom
              }}
            />
          </Grid>
          <Grid
            item
            container
            xs={12}
            justify="center"
            style={{ marginTop: "1em" }}
          >
            <Button
              disabled={transferPrice === 0 || isNaN(transferPrice)}
              variant="contained"
              color="primary"
              component="span"
              style={{ textTransform: "none", marginRight: "3px" }}
              onClick={() => handleDownloadIsapreFile()}
            >
              Descargar archivo para enviar a isapre
            </Button>
          </Grid>
          <Grid
            container
            direction="row"
            justify="center"
            alignItems="center"
            item
            xs={12}
        >
            <Grid
                container
                direction="row"
                justify="center"
                alignItems="center"
                item
                xs={12}
            >
                <TableComponent 
                    headers={header}
                    data={listAsssigned}
                />
            </Grid>
        </Grid>
          <Grid
            container
            direction="row"
            justify="center"
            alignItems="center"
            item
            xs={12}
        >
            <Grid
                container
                direction="row"
                justify="center"
                alignItems="center"
                item
                xs={12}
            >
                <TableComponent
                    headers={headerStop}
                    data={listStop}
                />
            </Grid>
        </Grid>
        <DocumentosAdjuntosTarea idTarea={tempRow.id} />
  </div>

  const _actions_ = <>
              <Button
            disabled={approvalFile === null || transferPrice === 0 || isNaN(transferPrice)}
            variant="contained"
            color="primary"
            style={{ textTransform: "none" }}
            onClick={() => uploadAuthorization()}
          >
            Autorizar con isapre
          </Button>
          <Button
            disabled={transferPrice === 0 || isNaN(transferPrice)}
            variant="contained"
            color="primary"
            style={{ textTransform: "none" }}
            onClick={() => uploadAuthorization(false, true)}
          >
            Autorizar con isapre y dejar pendiente archivo
          </Button>
          <Button
            disabled={transferPrice === 0 || isNaN(transferPrice)}
            variant="contained"
            color="primary"
            style={{ textTransform: "none" }}
            onClick={() => uploadAuthorization(false)}
          >
            Autorizar sin isapre
          </Button>
          <Button
            variant="contained"
            color="primary"
            style={{ textTransform: "none" }}
            onClick={rejectRequest}
          >
            Rechazar solicitud
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={closeModal}
            style={{ textTransform: "none" }}
          >
            Cerrar
          </Button>  
   </>

  return (
    <ModalDialog 
      open={openModal}
      onClose={closeModal}
      title={`Adjuntar autorización de traslado`}
      _content_={_content_}
      _actions_ = {_actions_}
      maxWidth="md"
    />
  );
};

export default ModalAddAuthorization;
